import React, { useEffect, useRef, useState } from "react";
import { CallIcon } from "../../GlobalAddDealModalV3/components/Icons";
import { IconButton, styled } from "@material-ui/core";
import { getVirtualNumbers, storeMultipleReducers } from "../../../actions/globalDialerAction";
import { connect, useDispatch, useSelector } from "react-redux";
import { HEADER_COLORS } from "./constants";
import GlobalDialerV2, { GLOBAL_DIALER_CALL_STATUS } from "../../user/globalDialerV2";
import Zoom from '@material-ui/core/Zoom';
import { setCallEnvironment, setGlobalDialerState } from "../../../reducers/globalDialerV2/globalDialerSlice";
import ColdTransfer from "../../user/globalDialerV2/ColdTransfer";
import Utils from "../../../helpers/Utils";
import CallDispositionModal from "../../user/globalDialerV2/CallDispositionModal";
import CallReviewModal from "../../user/globalDialerV2/CallReviewModal";
const HeaderGlobalDialerInsuranceWrapperV2 = styled("div")(({ theme }) => ({
    backgroundColor: "#212140",
    borderRadius: "10px",
    boxShadow: "0 0 17px 1px #bbb",
    right: "-165px",
    overflow: "visible",
    position: "absolute",
    top: "50px",
    width: "370px",
    zIndex: "999",

    '& input': {
        boxSizing: "border-box !important",
    },

    "& .dial-input-wrapper svg": {
        background: "#d3d3d3",
        borderRadius: "50%",
        height: "18px",
        width: "18px",
        position: "absolute",
        top: "25px",
        right: "16px"
    },

    "& .dial-search-wrapper svg": {
        position: "absolute",
        left: "20px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: "3"
    },

    "& .list-all-contact h5": {
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: ".01em",
        columns: "var(--dark-blue)"
    },

    "& .contact-info ul": {
        margin: "0"
    }
}));

const HeaderGlobalDialerInsurance = (props) => {
    const dispatch = useDispatch();
    const { callEnvironment, lastCaller } = useSelector((state) => (state.globalDialerV2));
    const [updateNumber, setUpdateNumber] = useState({ update: false, dialerContactNumber: null });
    const [openGlobalDialer, setOpenGlobalDialer] = useState(false);
    const [dialOccurrence, setDialOccurrence] = useState(0);
    const [openCallDispositionModal, setOpenCallDispositionModal] = useState(null);
    const [connectedCallerInfo, setConnectedCallerInfo] = useState(null);
    const [openCallReviewModal, setOpenCallReviewModal] = useState(null);
    const [callInfo, setCallInfo] = useState(null);
    const [openColdTransferred, setOpenColdTransferred] = useState(false);
    const [openColdTransferredFlag, setOpenColdTransferredFlag] = useState(false);
    const [callTime, setCallTime] = useState(0);
    const [timeOfCall, setTimeOfCall] = useState(null);
    const buttonRef2 = useRef(null);
    const popoverRef2 = useRef(null);
    const popoverRef3 = useRef(null);
    const popoverInnerRef2 = useRef(null);
    const { virtualNumbers } = useSelector((state) => (state.globalDialerV2));

    useEffect(() => {
        // dispatch(getVirtualNumbers());
        props.storeMultipleReducers({ virtualNumbers: virtualNumbers })
    }, [virtualNumbers]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        let interval = null;
        if (callEnvironment.isCallInProgress === true && (callEnvironment.incomingCallConnection === null || (callEnvironment.callStatus === GLOBAL_DIALER_CALL_STATUS.RECEIVED))) {
            interval = setInterval(() => {
                setCallTime((prevTime) => prevTime + 1);
            }, 1000);
        } else {
            clearInterval(interval);
            setCallTime(0);
        }

        return () => clearInterval(interval);
    }, [callEnvironment.isCallInProgress, callEnvironment.callStatus]);

    useEffect(() => {
        if (!openGlobalDialer) {
            setUpdateNumber((prev) => { return { update: !(prev.update), dialerContactNumber: null } });
        }
    }, [openGlobalDialer]);

    const handleClickOutside = (event) => {
        if (buttonRef2.current && !buttonRef2.current.contains(event.target)
            && popoverRef2.current && !popoverRef2.current.contains(event.target)
            && (popoverInnerRef2.current ? !popoverInnerRef2.current.contains(event.target) : true)) {
            setOpenGlobalDialer(false);
        }

        if (popoverRef3.current && !popoverRef3.current.contains(event.target)) {
            setOpenColdTransferred(false);
            setOpenColdTransferredFlag(false);
        }
    };

    window.initiateGlobalDialer = (contact = null, contactListInfo = null) => {
        if (contact != null) {
            if (contact.dialToNumber) {
                props.storeMultipleReducers({
                    stage: "dial",
                    dialNumber: contact.number
                });
                dispatch(setCallEnvironment({
                    isCallInProgress: true,
                    dialerNumber: contact.number
                }));
                setDialOccurrence((occur) => (occur + 1));
                localStorage.setItem("isDialFromMap", "true");
            } else {
                if (contactListInfo) {
                    props.storeMultipleReducers({
                        listCurrentIndex: contactListInfo.currentIndex ?? 0,
                        stage: "contact",
                        recentContacts: (contactListInfo.currentIndex) ? contactListInfo.contactList ?? [contact] : [contact]
                    });
                }
                setUpdateNumber({
                    stage: "contact",
                    update: !updateNumber.update,
                    dialerContactNumber: contact.number,
                    contactInfo: contact,
                    contactListInfo: contactListInfo
                });
            }
        } else {
            setUpdateNumber({
                update: false,
                dialerContactNumber: null,
                contactInfo: null,
                contactListInfo: contactListInfo
            });
        }

        setTimeout(() => {
            setOpenGlobalDialer(true);
        }, 1000);
    }

    window.updateVirtualNumberList = () => {
        dispatch(getVirtualNumbers());
    }

    const closeDialog = () => {
        localStorage.setItem("isDialFromMap", "false");
        if (openGlobalDialer) {
            setOpenGlobalDialer(false);
        }

        setDialOccurrence(0);
    };

    const handleOpenCallDispositionModal = (contact) => {
        setOpenGlobalDialer(false);
        setCallInfo(contact);
        setTimeout(() => {
            setOpenCallDispositionModal(contact);
        }, 500);
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return [
            minutes.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0'),
        ].join(':');
    };

    const hangUpCall = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (connectedCallerInfo !== null) {
            connectedCallerInfo.endCall();
        }
    };

    const handleToggleGlobalDialerV2 = () => {
        if (openColdTransferred) {
            handleCloseColdTransferred();
            setOpenGlobalDialer(true);
        } else {
            setOpenGlobalDialer((prevState) => (!prevState));
        }
    };

    const handleCloseColdTransferred = () => {
        setOpenColdTransferred(false);
        dispatch(setGlobalDialerState({
            lastCaller: null,
            lastCallTime: 0
        }));
    };

    return (
        <div style={{ position: "relative" }}>
            {
                callEnvironment.isCallInProgress && (callEnvironment.incomingCallConnection === null || (callEnvironment.callStatus === GLOBAL_DIALER_CALL_STATUS.RECEIVED)) ?
                    <IconButton className="actionButtonTimer" buttonRef={buttonRef2} onClick={handleToggleGlobalDialerV2}>
                        <div className="callEndSection">
                            <span style={{ fontSize: '15px' }}>{formatTime(callTime)}</span>
                            <div className="svgContainer d-flex justify-content-center align-items-center" onClick={hangUpCall}>
                                <svg width="24" height="16" viewBox="0 0 48 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.59628 18.5844C11.1269 17.0538 12.8691 15.7903 14.7639 14.8368C15.6998 14.377 16.3393 13.3007 16.3278 12.4374L17.0168 7.50435C22.0169 5.98456 26.0324 5.98391 30.9843 7.50299L31.6625 12.3003C31.6618 13.3698 32.2505 14.3423 33.2129 14.8448C35.1172 15.8038 36.8594 17.0658 38.3907 18.5971C39.4968 19.7033 41.2967 19.7033 42.4028 18.5972L46.9939 14.0061C48.1001 12.8999 48.1001 11.1001 46.9939 9.99394C34.3149 -2.68512 13.685 -2.68505 1.0059 9.99401C-0.10022 11.1001 -0.100223 12.9 1.0059 14.0061L5.58423 18.5845C6.69035 19.6904 8.49022 19.6904 9.59628 18.5844Z"
                                        fill="white" />
                                </svg>
                            </div>
                        </div>
                    </IconButton> :
                    callEnvironment.isCallInProgress && callEnvironment.incomingCallConnection !== null && callEnvironment.callStatus !== GLOBAL_DIALER_CALL_STATUS.RECEIVED ?
                        <IconButton className="actionButton ">
                            <CallIcon className="shaking-call-button" color={HEADER_COLORS.CALL_ICON} />
                        </IconButton> :
                        <IconButton buttonRef={buttonRef2} className="actionButton" onClick={handleToggleGlobalDialerV2}>
                            <CallIcon color={HEADER_COLORS.CALL_ICON} />
                        </IconButton>
            }

            {
               
                    <HeaderGlobalDialerInsuranceWrapperV2 ref={popoverRef2} style={{ visibility: (!openColdTransferred && openGlobalDialer) ? "visible" : "hidden" }}>
                        <GlobalDialerV2
                            openGlobalDialer={openGlobalDialer}
                            callTime={callTime}
                            popoverInnerRef2={popoverInnerRef2}
                            openDialog={() => setOpenGlobalDialer(true)}
                            closeDialog={() => closeDialog()}
                            dialOccurrence={dialOccurrence}
                            setConnectedCalledInfo={setConnectedCallerInfo}
                            OpenCallDispositionModal={handleOpenCallDispositionModal}
                            updateNumber={updateNumber}
                            openColdTransferred={() => {
                                setOpenColdTransferred(true);
                                setOpenColdTransferredFlag(true);
                            }}
                            closeColdTransferred={handleCloseColdTransferred}
                            setTimeOfCall={setTimeOfCall}
                            timeOfCall={timeOfCall}
                        />
                    </HeaderGlobalDialerInsuranceWrapperV2>
                
            }

            {
                <Zoom in={openColdTransferred}>
                    <HeaderGlobalDialerInsuranceWrapperV2 ref={popoverRef3} style={{ visibility: openColdTransferred ? "visible" : "hidden" }}>
                        <ColdTransfer initiateCalling={() => {
                            if (lastCaller) {
                                dispatch(setCallEnvironment({
                                    isCallInProgress: true,
                                    dialerNumber: Utils.cleanPhoneNumber(lastCaller?.number)
                                }));
                                setDialOccurrence((occur) => (occur + 1));
                                handleCloseColdTransferred();
                                setOpenGlobalDialer(true);
                                setOpenCallDispositionModal(null);
                            } else {
                                window.showNotification('error', 'Unable to call now. Try again later!');
                                handleCloseColdTransferred();
                            }
                        }} />
                    </HeaderGlobalDialerInsuranceWrapperV2>
                </Zoom>
            }

            {
                !!openCallDispositionModal && !openColdTransferredFlag &&
                <CallDispositionModal
                    open={!!openCallDispositionModal}
                    contact={openCallDispositionModal}
                    onClose={() => {
                        setOpenCallDispositionModal(null);
                    }}
                    onOpenReview={(data) => {
                        setOpenCallReviewModal(data);
                    }}
                />
            }

            {
                !!openCallReviewModal && !openColdTransferred &&
                <CallReviewModal
                    open={!!openCallReviewModal}
                    data={{
                        ...openCallReviewModal,
                        timeOfCall,
                        callInfo
                    }}
                    onClose={() => {
                        setOpenCallReviewModal(null);
                    }}
                />
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        listCurrentIndex: state.globalDialerReducer.listCurrentIndex,
        goToNextInList: state.globalDialerReducer.goToNextInList,
        recentContacts: state.globalDialerReducer.recentContacts,
        isCallInProgress: state.globalDialerReducer.isCallInProgress,
        callTime: state.globalDialerReducer.callTime,
        incomingCallConnection: state.globalDialerReducer.incomingCallConnection,
        callStatus: state.globalDialerReducer.callStatus,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        storeMultipleReducers: (params) => dispatch(storeMultipleReducers(params)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderGlobalDialerInsurance);